// Define types for endpoint configuration
import { getApiUrl } from '../../config/runtime.config'

export const apiConfig = {
  baseUrl() {
    return getApiUrl()
  },
  endpoints: {
    auth: {
      login: {
        url: '/webapp/login',
        method: 'POST',
        auth: false,
      },
    },
    payments: {
      create: {
        url: '/webapp/payments',
        method: 'POST',
        auth: true,
      },
      list: {
        url: '/webapp/payments',
        method: 'GET',
        auth: true,
      },
    },
  },
}
